export default __webpack_public_path__ + "2463ea66bb4b79b11d29a66c080824b0.png";